import api from './index';

export default {
  get() {
    return api.get(`article-categories`);
  },
};
